import { useState } from 'react'

import {
  useLazyListDataZonesQuery,
  useGetOneFatDataZoneQuery,
  useUpsertDataZoneMutation,
  useBulkUpdateDatazonesMutation,
  useUpdateListOfGeometryShapesForGeozoneIdMutation,
  useDeleteDataZoneMutation
} from '../apiSlice/datazoneApi'

import { getPushPull } from '../apiSlice/pushPullHelper'

import { useBulkUpdateGroupsMutation } from '../apiSlice/groupApi'

import useSearchCallback from '../apiSlice/useSearchCallback'
import useFetchAuxiliaryLists from '../apiSlice/useFetchAuxiliaryLists'
import { BucketConfig } from '../../sharedcomponents/5templates/detailCards/BucketConfig'
import { useNavigate } from 'react-router-dom'
import {
  ArtificialDetailPropertyNames,
  RootObjectTypes
} from '../../common/globalNotary'
const useDatazone = () => {
  const [loadDataZones] = useLazyListDataZonesQuery()
  const [bulkUpdateDataZonesCallBack] = useBulkUpdateDatazonesMutation()
  const [upsertDataZonePrimaryRecord] = useUpsertDataZoneMutation()
  const [updateListOfGeometryShapesForGeozoneId] =
    useUpdateListOfGeometryShapesForGeozoneIdMutation()
  const [bulkUpdateGroups] = useBulkUpdateGroupsMutation()
  const [deleteDataZone] = useDeleteDataZoneMutation()
  const navigate = useNavigate()

  const {
    searchPartiesCallback,
    searchContractsCallback,
    searchEntitiesCallback,
    searchIndustriesCallback,
    searchGroupsCallback,
    searchCountryStateCityCallback
  } = useSearchCallback()

  const {
    constructEntitiesByIdArrayCall,
    constructContractsByIdArrayCall,
    constructIndustriesByIdArrayCall,
    constructPartiesByIdArrayCall,
    constructValueAsPromiseCall
  } = useFetchAuxiliaryLists()

  const [finalAuxiliaryRecords, setFinalAuxiliaryRecords] = useState(null)

  const upsertDataZoneCallback = primaryDataZoneRecord => {
    const returnPromise = new Promise((resolve, reject) => {
      upsertDataZonePrimaryRecord(primaryDataZoneRecord)
        .unwrap()
        .then(primaryResult => {
          const id = primaryResult.data.id
            ? primaryResult.data.id
            : primaryResult.data.data.id

          if (primaryDataZoneRecord.type === 'commercial') {
            resolve({ id, type: RootObjectTypes.DATAZONE })
          }

          const roundTwoActions = []

          try {

            //the original code added for the assign / unassigning of items to the datazone used an outdated endpoint
            //This should be re-written in the future but for now we use the push pull identifiers to create the data structure to send to the API
            const { push, pull } = getPushPull(
              primaryDataZoneRecord,
              ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1,
              ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1_INITIAL_VALUES
            )

            const pushIds = push.map(group_id => ({
              id: group_id,
              item_id_assign: id
            })) || []

            const pullIds = pull.map(group_id => ({
              id: group_id,
              item_id_unassign: id
            })) || []

            const data = pushIds.concat(pullIds)

            if (data.length > 0)
            { 
              roundTwoActions.push(bulkUpdateGroups(data))
            }

            if (primaryDataZoneRecord.is_dynamic) {
              // aka geo fence
              const geoShapes = primaryDataZoneRecord[
                ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2
              ].map((o, i) => {
                if (o.isNew) {
                  o.id = null
                }
                delete o.isNew

                if (!o.hasOwnProperty('lat')) {
                  o.lat = null
                }

                if (!o.hasOwnProperty('long')) {
                  o.long = null
                }

                if (o.hasOwnProperty('wkt') && o.wkt) {
                  o.radius = null
                } else {
                  o.wkt = null
                }

                if (o.hasOwnProperty('radius') && o.radius) {
                  o.radius = Math.round(Number(o.radius))
                }

                return o
              })
              
              //If a group is type "commercial" then the response from the datazone API for geozones will be empty
              //and we will have nothing to send to the geozone API
              if (geoShapes.length > 0)
              {
                roundTwoActions.push(
                  updateListOfGeometryShapesForGeozoneId({ id, data: geoShapes })
                )
              }
            }

            Promise.all(roundTwoActions)
              .then(res => {
                resolve({ id, type: RootObjectTypes.DATAZONE })
              })
              .catch(e => {
                console.log(e)
                reject(e)
              })
          } catch (err) {
            console.log(err)
            document.getElementById('demo').innerHTML = err.message
          }
        })
        .catch(e => reject(e))
    })

    return returnPromise
  }

  const constructAndSetFinalListBucket = (
    completeResponse,
    primaryDataZoneRecord
  ) => {
    const zoneType = primaryDataZoneRecord.type
    const finalListBuckets = {}
    finalListBuckets.primero = [
      new BucketConfig(
        completeResponse[0].data,
        searchPartiesCallback,
        'Datazone Owner',
        null,
        'genericSelect',
        'user'
      )
    ]
    switch (zoneType) {
      case 'commercial':
        finalListBuckets.segundo = [
          new BucketConfig(
            completeResponse[1].data,
            searchIndustriesCallback,
            'Industry Type',
            null
          )
        ]
        finalListBuckets.tercero = [
          new BucketConfig(
            completeResponse[2].data,
            searchEntitiesCallback,
            'Entity',
            null
          ),
          new BucketConfig(
            completeResponse[3].data,
            searchContractsCallback,
            'Account',
            null
          )
        ]
        break
      case 'geo':
        if (primaryDataZoneRecord.is_dynamic) {
          finalListBuckets.segundo = [
            new BucketConfig(
              completeResponse[1].data,
              null,
              'Geo fencing',
              null,
              'mapSelect'
            )
          ]
        } else {
          finalListBuckets.segundo = [
            new BucketConfig(
              completeResponse[1].data,
              searchCountryStateCityCallback,
              'Territory Set',
              null,
              'addressSelect'
            )
          ]
        }
        finalListBuckets.tercero = [
          new BucketConfig(
            completeResponse[2].data,
            searchGroupsCallback,
            'Territory Group',
            { type: 'territory' }
          )
        ]

        break
      default:
        throw new Error(`unknow group type: ${zoneType}`)
    }
    setFinalAuxiliaryRecords(finalListBuckets)
  }

  const datazoneTypes = ['commercial', 'geo']
  const commercialZoneTypes = ['static', 'dynamic']
  const geoZoneTypes = ['poly', 'civic']

  const fetchAuxiliaryRecords = async primaryDataZoneRecord => {
    // console.log('constructing aux call for datazone')
    // console.log(primaryDataZoneRecord)
    const fetchCallArray = [
      constructPartiesByIdArrayCall(primaryDataZoneRecord, 'owner_ids')
    ]

    switch (primaryDataZoneRecord.type) {
      case 'geo':
        if (primaryDataZoneRecord.is_dynamic) {
          // geo fence
          fetchCallArray.push(
            constructValueAsPromiseCall(
              ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2,
              primaryDataZoneRecord[
                ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2
              ]
            )
          )
        } else {
          // civic
          //addresses
          var temp = []
          primaryDataZoneRecord.addresses.forEach(address => {
            temp.push({
              'name': `${address.city ?? ''} ${address.region ?? ''} ${address.country}`
            })
          })

          fetchCallArray.push(
            constructValueAsPromiseCall(
              'addresses',
              temp
            )
          )
        }
        fetchCallArray.push(
          constructValueAsPromiseCall(
            ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1,
            primaryDataZoneRecord[
              ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1
            ]
          )
        )

        break
      case 'commercial':
        fetchCallArray.push(
          constructIndustriesByIdArrayCall(
            primaryDataZoneRecord,
            'industry_ids'
          )
        )
        fetchCallArray.push(
          constructEntitiesByIdArrayCall(primaryDataZoneRecord, 'entity_ids')
        )
        fetchCallArray.push(
          constructContractsByIdArrayCall(primaryDataZoneRecord, 'contract_ids')
        )

        break
      default:
        throw new Error(`unknown datazone type: ${primaryDataZoneRecord.type}`)
    }
    /// this Promise.all will not reject, errors come back on the error object,
    /// if everything works out, the error object is null or undefined
    Promise.all(fetchCallArray.map(f => f.call())).then(res => {
      constructAndSetFinalListBucket(res, primaryDataZoneRecord)
    })
  }

  const typeIdToDisplayName = type => {
    switch (type) {
      case 'geo':
        return 'Geo Zone'
      case 'commercial':
        return 'Commercial Zone'
      default:
        return ''
    }
  }

  const typeIdToDisplayNameCommercial = type => {
    switch (type) {
      case 'dynamic':
        return 'Dynamic Zone'
      case 'static':
        return 'Static Zone'
      default:
        return ''
    }
  }

  const typeIdToDisplayNameGeo = type => {
    switch (type) {
      case 'poly':
        return 'Geo Fence'
      case 'civic':
        return 'Civic Zone'
      default:
        return ''
    }
  }

  const makeInMemoryDatazoneRecord = (type, subType) => {
    const is_dynamic =
      subType === 'poly' || subType === 'dynamic' ? true : false
    const returnValue = {
      name: '',
      description: '',
      is_system: false,
      owner_ids: [],
      addresses: [],
      industry_ids: [],
      entity_ids: [],
      contract_ids: [],
      type,
      is_dynamic
    }

    returnValue[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1] = []

    returnValue[
      ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1_INITIAL_VALUES
    ] = []

    return returnValue
  }

  const removeDataZone = async id => {
    deleteDataZone({ id }).then(() => {
      navigate(-1)
    }).catch(err => {
      console.error(err)
      alert('Could not delete account. Please check that other objects do not depend on it.')
    })
  }

  const suspendDatazone = async (id, active) => {
    bulkUpdateDataZonesCallBack([
      { id, suspended_at: active ? null : new Date() }
    ])
  }

  return {
    typeIdToDisplayName,
    typeIdToDisplayNameCommercial,
    typeIdToDisplayNameGeo,
    loadDataZones,
    bulkUpdateDataZonesCallBack,
    useGetOneFatDataZoneQuery,
    fetchAuxiliaryRecords,
    makeInMemoryDatazoneRecord,
    datazoneTypes,
    commercialZoneTypes,
    geoZoneTypes,
    finalAuxiliaryRecords,
    upsertDataZoneCallback,
    removeDataZone,
    suspendDatazone
  }
}

export default useDatazone
